const VerifyToken = () => {
  const now = new Date();
  const expiryStoraged = localStorage.getItem('BLOX_USER_TOKEN_EXPIRY');
  const tokenExpiry = expiryStoraged && JSON.parse(expiryStoraged);

  return now.getUTCMilliseconds() <= tokenExpiry;
};

export default VerifyToken;
